import React from "react";
import {
  Input,
  Button,
  Avatar,
} from "@fluentui/react-components";

import {
  Search24Regular,
  Add24Regular,
  SignOut24Regular,
} from "@fluentui/react-icons";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import defaultLogo from "../assets/logo.png";

export default function Topbar() {
  const navigate = useNavigate();

  const {
    user,
    workspace,
    role,
    signOut,
  } = useAuth();

  async function handleLogout() {
    await signOut();
    navigate("/login");
  }

  const workspaceName =
    workspace?.name || "Workspace";

  const userEmail =
    user?.email || "";

  return (
    <header className="flex h-[56px] items-center justify-between border-b border-[#edebe9] bg-white px-6">
      {/* LEFT */}
      <div className="flex items-center gap-4">
        <img
          src={defaultLogo}
          alt={workspaceName}
          className="h-8 w-auto"
        />

        <div className="flex flex-col leading-tight">
          <span className="text-sm font-semibold text-[#201f1e]">
            {workspaceName}
          </span>

          <span className="text-xs text-[#605e5c]">
            {role || "member"}
          </span>
        </div>
      </div>

      {/* CENTER */}
      <div className="w-[420px]">
        <Input
          placeholder="Søg projekter, kunder, tilbud..."
          contentBefore={<Search24Regular />}
        />
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-3">
        <Button
          appearance="primary"
          icon={<Add24Regular />}
          onClick={() => navigate("/quotes")}
        >
          Nyt tilbud
        </Button>

        <div className="flex items-center gap-3 rounded-md border border-[#edebe9] px-3 py-1.5">
          <div className="text-right leading-tight">
            <div className="text-xs font-medium text-[#201f1e]">
              {userEmail}
            </div>

            <div className="text-[11px] text-[#605e5c]">
              {workspaceName}
            </div>
          </div>

          <Avatar
            name={userEmail}
            size={32}
          />
        </div>

        <Button
          appearance="subtle"
          icon={<SignOut24Regular />}
          onClick={handleLogout}
        >
          Logout
        </Button>
      </div>
    </header>
  );
}